export var MESSAGE_TEMPLATE_TYPES = [
    "URGENCE",
    "PERIODICAL_URGENCE",
    "REMINDER",
    "PERIODICAL_REMINDER",
    "DAMAGED_CLAIM",
    "PERIODICAL_DAMAGED_CLAIM",
    "REQUEST",
    "PERIODICAL_ISSUE_INQUIRY",
];
export var MESSAGE_TEMPLATE_TYPE_LABEL_IDS = {
    URGENCE: "ui-br-legaldeposits.libraries.messageTemplates.type.URGENCE",
    PERIODICAL_URGENCE: "ui-br-legaldeposits.libraries.messageTemplates.type.PERIODICAL_URGENCE",
    REMINDER: "ui-br-legaldeposits.libraries.messageTemplates.type.REMINDER",
    PERIODICAL_REMINDER: "ui-br-legaldeposits.libraries.messageTemplates.type.PERIODICAL_REMINDER",
    DAMAGED_CLAIM: "ui-br-legaldeposits.libraries.messageTemplates.type.DAMAGED_CLAIM",
    PERIODICAL_DAMAGED_CLAIM: "ui-br-legaldeposits.libraries.messageTemplates.type.PERIODICAL_DAMAGED_CLAIM",
    REQUEST: "ui-br-legaldeposits.libraries.messageTemplates.type.REQUEST",
    PERIODICAL_ISSUE_INQUIRY: "ui-br-legaldeposits.libraries.messageTemplates.type.PERIODICAL_ISSUE_INQUIRY",
};
